import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type SpinnerType = 'bars' | 'dots' | 'pulse' | 'wave' | 'circle' | 'bouncing' | 'folding' | 'cube' | 'spinning' | 'text' | 'sphere';
@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private isLoadingSubject = new BehaviorSubject<boolean>(false);
    private loadingTextSubject = new BehaviorSubject<string>('Cargando...');
    private loadingSpinnerTypeSubject = new BehaviorSubject<SpinnerType | 'random'>('random');
    private activeRequests = 0;

    isLoading$ = this.isLoadingSubject.asObservable();
    loadingText$ = this.loadingTextSubject.asObservable();
    loadingSpinnerType$ = this.loadingSpinnerTypeSubject.asObservable();

    // Getter público para acceder al valor actual
    get currentSpinnerType(): SpinnerType | 'random' {
        return this.loadingSpinnerTypeSubject.value;
    }

    constructor(private ngZone: NgZone) { }

    show(text?: string, spinnerType?: SpinnerType | 'random') {
        this.ngZone.run(() => {
            if (text) {
                this.loadingTextSubject.next(text);
            }
            if (spinnerType) {
                this.loadingSpinnerTypeSubject.next(spinnerType);
            } else {
                this.loadingSpinnerTypeSubject.next('random');
            }
            this.activeRequests++;
            this.isLoadingSubject.next(true);
        });
    }

    hide() {
        this.ngZone.run(() => {
            this.activeRequests = Math.max(0, this.activeRequests - 1);
            if (this.activeRequests === 0) {
                this.isLoadingSubject.next(false);
                setTimeout(() => { }, 0);
            }
        });
    }

    setText(text: string) {
        this.ngZone.run(() => {
            this.loadingTextSubject.next(text);
        });
    }

    setSpinnerType(spinnerType: SpinnerType | 'random') {
        this.ngZone.run(() => {
            this.loadingSpinnerTypeSubject.next(spinnerType);
        });
    }

    forceHide() {
        this.ngZone.run(() => {
            this.activeRequests = 0;
            this.isLoadingSubject.next(false);
            setTimeout(() => { }, 0);
        });
    }
}